module.exports = __webpack_public_path__ + "img/gray-90rotate-icon-01.10d201a6.svg";